import React from "react";

const IterativeLinearSolversIcon = ({ size = 40, className = "" }) => (
  <svg
    viewBox="-23 -10 153 120"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Concentric ellipses (level sets) */}
    {[
      [20, 15],
      [50, 37],
      [80, 60],
    ].map(([rx, ry], i) => (
      <ellipse
        key={i}
        cx="60"
        cy="35"
        rx={rx}
        ry={ry}
        transform="rotate(48 38 32)"
        fill="none"
        stroke="#f3f4f6"
        strokeWidth="8"
      />
    ))}

    {/* Connecting path (x0 -> x1 -> x2 -> x3 -> x) */}
    <polyline
      points="10,120 45,105 25,60 51.5,50.5"
      fill="none"
      stroke="#f3f4f6"        // soft red
      strokeWidth="10"
      strokeLinecap="round"

    />

    <circle cx="51.5" cy="50.5" r="5.5" fill="#f3f4f6" />  {/* final x */}
  </svg>
);

export default IterativeLinearSolversIcon;
